import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import PanelContainer from 'components/PanelContainer';
import LinkButton from 'components/LinkButton';
import BasicControlGroup from 'components/BasicControlGroup';

import './styles.css';

const FirmSection = props => {
  const {
    title,
    action,
    linkCaption,
    children,
    controls,
    header,
    frameless,
  } = props;

  const controlsEl = useMemo(
    () =>
      controls && (
        <div className="firm-tab-section__control">
          <BasicControlGroup>
            {controls.length > 0 &&
              controls.map(c => (
                <LinkButton
                  key={c.caption}
                  text={c.caption}
                  controlFunc={c.handler}
                />
              ))}
          </BasicControlGroup>
        </div>
      ),
    [controls]
  );

  const panelStyles = frameless
    ? {
        border: 'none',
        background: 'none',
        boxShadow: 'none',
        padding: '0',
      }
    : '';

  return (
    <section className="firm-tab-section">
      <PanelContainer styles={panelStyles}>
        <div className="firm-tab-section__header">
          {!header ? (
            <>
              <h2 className="firm-tab-section__title">{title}</h2>
              {controlsEl}
            </>
          ) : (
            header
          )}
        </div>

        <div className="firm-tab-section__content">{children}</div>
        {linkCaption && action && (
          <div className="firm-tab-section__footer">
            <a onClick={action} className="firm-tab-section__link">
              {linkCaption}
            </a>
          </div>
        )}
      </PanelContainer>
    </section>
  );
};

FirmSection.propTypes = {
  title: PropTypes.string,
  action: PropTypes.func,
  linkCaption: PropTypes.string,
  controls: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default FirmSection;
